import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SpacingHorizontalLargeIcon = React.forwardRef(
  function SpacingHorizontalLargeIcon(props, ref) {
    const { color, size, ...otherProps } = props
    const clipPathId = useId()

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        {...otherProps}
      >
        <g clipPath={`url(#${clipPathId})`}>
          <path d="M1 0C.45 0 0 .45 0 1V23C0 23.55.45 24 1 24 1.55 24 2 23.55 2 23V1C2 .45 1.55 0 1 0ZM23 0C22.45 0 22 .45 22 1V23C22 23.55 22.45 24 23 24 23.55 24 24 23.55 24 23V1C24 .45 23.55 0 23 0ZM15 0H9V24H15V0Z"></path>
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <path fill="white" d="M0 0H24V24H0z"></path>
          </clipPath>
        </defs>
      </svg>
    )
  }
)

SpacingHorizontalLargeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SpacingHorizontalLargeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SpacingHorizontalLargeIcon
